module.exports = __webpack_public_path__ + "img/icon3.f4bde571.png";